﻿import 'regenerator-runtime/runtime'

import '../../Styles/app.scss'

import { Vue } from './vue-init'
import vuetify from './vuetify-init'
import { MOUNT_APP } from './constants'

const PageMixin = {
    data: () => ({
        drawer: null
    })
}

export { Vue, vuetify, MOUNT_APP, PageMixin }